import request from "../../services/request";
import { CONTENT_OR_CONFIG_TABLE_MAPPING } from "../../utils/constants";
import { adSign, bannerStringGenerator,footerkeyGenerator } from "../../utils/validation";
const APPLICATION_JSON = "application/json";

export const fetchContentOrConfig = async (payload?: { role: string, managedEquipment: boolean }) => {
  let queryPayloads: any[] = [
  
    {
      configTable: `${CONTENT_OR_CONFIG_TABLE_MAPPING?.Global?.tableName}`,
      configFilter: `KEY~${CONTENT_OR_CONFIG_TABLE_MAPPING?.Global?.REDIRECT_FALLBACK_URL}`,
    },
    {
      configTable: `${CONTENT_OR_CONFIG_TABLE_MAPPING?.Global?.tableName}`,
      configFilter: `KEY~${CONTENT_OR_CONFIG_TABLE_MAPPING?.Global?.QUOTE_LOGO_URL}`,
    },
    {
      configTable: `${CONTENT_OR_CONFIG_TABLE_MAPPING?.Global?.tableName}`,
      configFilter: `KEY~${CONTENT_OR_CONFIG_TABLE_MAPPING?.Global?.WIZARD_GLOBAL_REDIRECT_URL}`,
    }
  ];
  if (payload?.role) {
    queryPayloads.push({
      contentType: `${CONTENT_OR_CONFIG_TABLE_MAPPING?.Global?.banner}`,
      contentFilter: `name~${bannerStringGenerator(payload?.role, payload?.managedEquipment)}`,
    });
   
    queryPayloads.push({
      contentType: `${CONTENT_OR_CONFIG_TABLE_MAPPING?.Global?.FOOTER_CONTENT_TYPE}`,
      contentFilter: `name~${footerkeyGenerator(payload?.role)}`,
    });
    queryPayloads.push({
      contentType: `${CONTENT_OR_CONFIG_TABLE_MAPPING?.Global?.FOOTER_CONTENT_TYPE}`,
      contentFilter: `name~${adSign(payload?.role)}`,
    });

  }
  try {
    const response: any = request([
      "GLOBAL",
      "CONTENTORCONFIG",
      queryPayloads,
      APPLICATION_JSON,
    ]);
    return response;
  } catch (err) {
    console.error("Activity : ", err);
    return null;
  }
};
